module.exports = __webpack_public_path__ + "img/tusd.41dc11b1.svg";